import { template as template_4ea1f71096064b2eb5b0c5d9770b2e3e } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import styles from './mobile-clinician-search-header.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchMobileClinicianSearchHeader extends Component {
    styles = styles;
    static{
        template_4ea1f71096064b2eb5b0c5d9770b2e3e(`
    <div
      class="mobile-clinician-search-header d-md-none {{styles.component}}"
      data-test-mobile-clinician-search-header
      ...attributes
    >
      <div class="heading-row">
        <h2 class="heading" data-test-mobile-clinician-search-header-title>
          {{t "booking.steps.clinician"}}
        </h2>
        <button
          type="button"
          class="close-button"
          aria-label={{t "shared.actions.close"}}
          data-test-mobile-clinician-search-header-close
          {{on "click" @onClose}}
        >
          {{svgJar "clinician-search-close" aria-hidden="true"}}
        </button>
      </div>
      <div class="teaser-slot">
        {{yield}}
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
